import * as React from "react";
import { Flex, Text, Button } from "@radix-ui/themes";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { radixThemeDataAttributes } from "@/components/Theme";

interface PopoverWithDefaultsProps {
  trigger: React.ReactNode;
  title: string;
  description: string;
  titleWeight?: "medium" | "bold" | "regular";
  buttonText?: string;
  onButtonClick?: () => void;
  buttonVariant?: "solid" | "outline" | "ghost";
  buttonColor?: "gray" | "blue" | "green" | "red" | "yellow";
  buttonHighContrast?: boolean;
}

export function PopoverWithDefaults({
  trigger,
  title,
  description,
  titleWeight = "medium",
  buttonText,
  onButtonClick,
  buttonVariant = "solid",
  buttonColor = "gray",
  buttonHighContrast = false,
}: PopoverWithDefaultsProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent className="radix-themes" {...radixThemeDataAttributes}>
        <Flex direction="column" gap="2">
          <Text size="2" color="gray" highContrast weight={titleWeight}>
            {title}
          </Text>
          <Text size="2" color="gray">
            {description}
          </Text>
          {buttonText && onButtonClick && (
            <Button
              size="1"
              variant={buttonVariant}
              color={buttonColor}
              highContrast={buttonHighContrast}
              onClick={onButtonClick}
              style={{ marginTop: "4px" }}
            >
              {buttonText}
            </Button>
          )}
        </Flex>
      </PopoverContent>
    </Popover>
  );
}
